import React, { Component } from 'react';

class SucursalesSeleccionadasItem extends Component {
    render() {
        return (
            this.props.id != 0 &&
            <li className="inlineListItem right-separator-xxs">
                <div className="btn-group top-separator-xxxs">
                    <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-left not-clickable">{this.props.descripcion}</button>
                    <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-right" onClick={() => this.props.removeSelectedBranch(this.props.id, 'sucursal')}>
                        <span key={this.props.key} className="ti-close span-closable color-white" title="Quitar sucursal."></span>
                    </button>
                </div>
            </li>
        );
    }
};

export default SucursalesSeleccionadasItem;